import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

export interface CollegeCenter {
  CgCode: string;
  CgName: string;
  StudentCount: number;
  Cent: string;
  CentName: string;
  SelectedCenter?: any;
  IsSelected?: boolean;
  OriginalCent?: string;
  OriginalCentName?: string;
  IsFinal?: string; // 'Y' or 'N'
  FinalCount?: number;
  RollNo?: string;
}

export interface Center {
  CgCode: string;
  CgName: string;
}

@Component({
  selector: 'app-new-center-allocation',
  templateUrl: './new-center-allocation.component.html',
  styleUrls: ['./new-center-allocation.component.scss']
})
export class NewCenterAllocationComponent implements OnInit {
  CenterAllocationForm: FormGroup;
  
  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  
  fcCodeList: any[] = [];
  filteredListFcCode: any[] = [];
  CourseList: any[] = [];
  filteredListCourse: any[] = [];
  examList: any[] = [];
  ExamFilterList: any[] = [];
  
  allCentersList: Center[] = [];
  filteredCenterList: Center[] = [];
  tempFilteredCenterList: Center[] = [];
  
  collegeList: CollegeCenter[] = [];
  istableShow = false;
  SessionNo: any;
  
  selectedExamId: number = 0;
  selectedShift: any = null;
  
  userPermission: any;
  utp: string;
  canUpdate = true;
  
  dialogRef: MatDialogRef<any>;

  searchTerm: string = '';
  isGeneratingRollNo: boolean = false;
  isSubmittingFinal: boolean = false;
  isGeneratingReport: boolean = false;

  constructor(
    private fb: FormBuilder,
    private umsService: UmsService,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.umsService.getSecretData().subscribe((res) => {
        this.SessionNo = res.projectPharam['SnNo'];
        this.fetchSessionList();
        this.fetchExamSchedule(this.SessionNo);
      });
    } else {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.fetchSessionList();
      this.fetchExamSchedule(this.SessionNo);
    }

    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Center-Allocation' && element.PUpdate == false) {
          this.canUpdate = false;
        }
      });
    }

    this.CenterAllocationForm = this.fb.group({
      SessionId: new FormControl('', Validators.required),
      CoFcCode: new FormControl(''),
      CoCode: new FormControl(''),
      Exam: new FormControl('', Validators.required)
    });

    this.fetchFacultyCode();
    this.fetchAllCenters();
  }

  fetchSessionList() {
    this.spinner.show();
    const payload = {
      SnActive: 'Y'
    };
    this.umsService.getSession(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.sessionList = res.data || [];
          this.SessionFilterList = [...this.sessionList];
        } else {
          this.sessionList = [];
          this.SessionFilterList = [];
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.sessionList = [];
        this.SessionFilterList = [];
        let data = {
          message: error.error?.message || 'Failed to fetch sessions.',
          title: 'Error',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  onSessionChange(sessionId: any) {
    this.SessionNo = sessionId;
    this.CenterAllocationForm.patchValue({ 
      CoFcCode: null, 
      CoCode: null, 
      Exam: null 
    });
    this.CourseList = [];
    this.filteredListCourse = [];
    this.istableShow = false;
    this.collegeList = [];
    this.selectedShift = null;
    this.ExamFilterList = [];
    
    if (sessionId) {
      this.fetchExamSchedule(sessionId);
    }
  }

  fetchFacultyCode() {
    this.umsService.getFaculty({}).subscribe(res => {
      if (res.status) {
        this.fcCodeList = res.data || [];
        this.filteredListFcCode = [...this.fcCodeList];
      }
    });
  }

  fetchExamSchedule(SnNo: number) {
    this.spinner.show();
    const payload = {
      ShSnNo: SnNo,
      LoginId: sessionStorage.getItem('userId'),
      ShStatus: ""
    };
    this.umsService.getExamSch(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.examList = res.data;
        this.ExamFilterList = [...this.examList];
      } else {
        this.examList = [];
        this.ExamFilterList = [];
      }
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.examList = [];
      this.ExamFilterList = [];
    });
  }

  fetchAllCenters() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.allCentersList = res.data || [];
          this.filteredCenterList = [...this.allCentersList];
          this.tempFilteredCenterList = [...this.allCentersList];
        } else {
          this.allCentersList = [];
          this.filteredCenterList = [];
          this.tempFilteredCenterList = [];
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.allCentersList = [];
        this.filteredCenterList = [];
        this.tempFilteredCenterList = [];
        let data = {
          message: error.error?.message || 'Failed to fetch centers.',
          title: 'Error',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  applyFilter(event: any) {
    let search = event.target.value;
    this.searchTerm = search.toLowerCase();
    if (this.searchTerm === '') {
      this.tempFilteredCenterList = [...this.allCentersList];
    } else {
      this.tempFilteredCenterList = this.allCentersList.filter(center => 
        center.CgCode?.toLowerCase().includes(this.searchTerm) || 
        center.CgName?.toLowerCase().includes(this.searchTerm)
      );
    }
  }

  onCenterFiltered(filteredList: any[]) {
    this.tempFilteredCenterList = filteredList;
  }

  onFacultyChange(fcCode: any) {
    this.CenterAllocationForm.patchValue({ CoCode: null, Exam: null });
    this.CourseList = [];
    this.filteredListCourse = [];
    this.istableShow = false;
    this.collegeList = [];
    this.selectedShift = null;

    if (fcCode) {
      this.getCourse(fcCode);
    }
  }

  getCourse(facultyCode: string) {
    this.spinner.show();
    const payload = { CoFcCode: facultyCode };
    this.umsService.getCourse(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.CourseList = res.data;
          this.filteredListCourse = [...this.CourseList];
        } else {
          this.CourseList = [];
        }
      },
      error: () => {
        this.spinner.hide();
        this.CourseList = [];
      }
    });
  }

  onCourseChange(coCode: any) {
    this.CenterAllocationForm.patchValue({ Exam: null });
    this.istableShow = false;
    this.collegeList = [];
    this.selectedShift = null;

    if (coCode) {
      this.spinner.show();
      const payload = { EmCoCode: coCode };
      this.umsService.getExam(payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res.status && res.data) {
            const examIds = res.data.map(exam => exam.EmId);
            this.ExamFilterList = this.examList.filter(shift => 
              examIds.includes(shift.ShEmId)
            );
          } else {
            this.ExamFilterList = [];
          }
        },
        error: () => {
          this.spinner.hide();
          this.ExamFilterList = [];
        }
      });
    } else {
      this.ExamFilterList = [];
    }
  }

  onExamChange(shId: any) {
    if (!shId) {
      this.istableShow = false;
      this.collegeList = [];
      this.selectedShift = null;
      return;
    }

    this.selectedExamId = shId;
    const selectedShiftObj = this.ExamFilterList.find(shift => shift.ShId == shId);
    if (!selectedShiftObj) {
      this.istableShow = false;
      return;
    }

    this.selectedShift = selectedShiftObj;
    this.fetchCollegeCenters(shId);
  }

  fetchCollegeCenters(shId: number) {
    this.spinner.show();
    this.istableShow = true;

    const payload: any = {
      ShId: shId
    };

    this.umsService.getCollegeCenters(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        console.log('API Response:', res);
        
        if (res.status && res.data) {
          console.log('Data from API:', res.data);
          
          this.collegeList = res.data.map((item: any) => {
            console.log('Processing item:', item);

            const centName = item.CentName ? item.CentName.trim() : '';
            const cent = item.Cent ? item.Cent.trim() : '';
            let selectedCenter = null;
            if (cent) {
              selectedCenter = this.allCentersList.find(c => c.CgCode === cent);
              if (!selectedCenter && cent) {
                selectedCenter = {
                  CgCode: cent,
                  CgName: centName || cent
                };
              }
            }
            
            const mappedItem = {
              CgCode: item.CgCode || '',
              CgName: item.CgName || '',
              StudentCount: item.StudentCount || 0,
              Cent: cent,
              CentName: centName,
              SelectedCenter: selectedCenter,
              IsSelected: selectedCenter !== null,
              OriginalCent: cent,
              OriginalCentName: centName,
              IsFinal: item.IsFinal || 'N',
              FinalCount: item.FinalCount || 0,
              RollNo: item.RollNo || ''
            };
            
            console.log('Mapped item:', mappedItem);
            return mappedItem;
          });
          
          console.log('Final collegeList:', this.collegeList);
          
          if (this.collegeList.length === 0) {
            let data = {
              message: 'No colleges found for the selected exam.',
              title: 'Information',
              icon: 'fas fa-info-circle'
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
        } else {
          this.collegeList = [];
          let data = {
            message: res.message || 'No data found for the selected exam.',
            title: 'Information',
            icon: 'fas fa-info-circle'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.collegeList = [];
        let data = {
          message: error.error?.message || 'Failed to fetch college centers. Please try again.',
          title: 'Error',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  areAllCentersAssigned(): boolean {
    if (this.collegeList.length === 0) return false;
    return this.collegeList.every(college => 
      college.Cent && college.Cent.trim() !== '' && 
      college.CentName && college.CentName.trim() !== ''
    );
  }

  isGenerateRollNoEnabled(): boolean {
    return this.istableShow && 
           this.CenterAllocationForm.get('SessionId')?.value &&
           this.CenterAllocationForm.get('CoFcCode')?.value &&
           this.CenterAllocationForm.get('CoCode')?.value &&
           this.CenterAllocationForm.get('Exam')?.value &&
           this.collegeList.length > 0 &&
           !this.isAllFinalized() &&
           this.areAllCentersAssigned();
  }

 
  isSubmitFinalEnabled(): boolean {
    if (!this.istableShow || this.collegeList.length === 0) {
      return false;
    }

    const allHaveCenters = this.areAllCentersAssigned();
    const hasNonFinal = this.collegeList.some(college => college.IsFinal === 'N');

    return allHaveCenters && hasNonFinal && !this.isSubmittingFinal;
  }

  // Check if all records are finalized
  isAllFinalized(): boolean {
    if (this.collegeList.length === 0) return false;
    return this.collegeList.every(college => college.IsFinal === 'Y');
  }

  isExamFinalized(): boolean {
    return this.isAllFinalized();
  }

  getFinalizedCount(): number {
    return this.collegeList.filter(college => college.IsFinal === 'Y').length;
  }

  getCollegesWithoutCenters(): number {
    return this.collegeList.filter(college => 
      !college.Cent || college.Cent.trim() === ''
    ).length;
  }

  // ========== SUBMIT FINAL ==========
  submitFinal() {
    if (!this.selectedExamId) {
      let data = {
        message: 'Please select an exam first.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    const missingCenters = this.collegeList.filter(college => 
      !college.Cent || college.Cent.trim() === ''
    );

    if (missingCenters.length > 0) {
      let data = {
        message: `Cannot submit final. ${missingCenters.length} college(s) do not have centers assigned. Please assign centers to all colleges first.`,
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    if (this.isAllFinalized()) {
      let data = {
        message: 'All records are already finalized.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    let confirmData = {
      message: `Are you sure you want to submit final for this exam? This action cannot be undone.`,
      title: 'Confirm Submit Final',
      icon: 'fa fa-question'
    };
    
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, confirmData);
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.performSubmitFinal();
      }
    });
  }

  performSubmitFinal() {
    this.isSubmittingFinal = true;
    this.spinner.show();

    const payload = {
      ShId: this.selectedExamId
    };

    this.umsService.submitFinal(payload).subscribe({
      next: (res: any) => {
        this.isSubmittingFinal = false;
        this.spinner.hide();
        
        if (res.status) {
          let data = {
            message: res.message || 'Final submission completed successfully!',
            title: 'Success',
            icon: 'fas fa-check'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          
          this.fetchCollegeCenters(this.selectedExamId);
        } else {
          if (res.missingStudents && res.missingStudents.length > 0) {
            let missingDetails = res.missingStudents.map((student: any) => 
              `${student.RegistrationNo} - ${student.StudentName} (${student.CollegeCode}): Center: ${student.CenterStatus}, Roll No: ${student.RollNoStatus}`
            ).join('\n');
            
            let data = {
              message: `${res.message}\n\nMissing Details:\n${missingDetails}`,
              title: 'Error',
              icon: 'fas fa-close'
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          } else {
            let data = {
              message: res.message || 'Failed to submit final.',
              title: 'Error',
              icon: 'fas fa-close'
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.isSubmittingFinal = false;
        this.spinner.hide();
        
        let errorMessage = error.error?.message || 'Failed to submit final. Please try again.';
        let data = {
          message: errorMessage,
          title: 'Error',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  generateRollNumbers() {
    if (!this.selectedExamId) {
      let data = {
        message: 'Please select an exam first.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    const missingCenters = this.collegeList.filter(college => 
      !college.Cent || college.Cent.trim() === ''
    );

    if (missingCenters.length > 0) {
      let data = {
        message: `Cannot generate roll numbers. ${missingCenters.length} college(s) do not have centers assigned. Please assign centers to all colleges first.`,
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    // Check if any records are already finalized
    if (this.isAllFinalized()) {
      let data = {
        message: 'Cannot generate roll numbers. All records are already finalized.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    // Confirm before generating roll numbers
    let confirmData = {
      message: `Are you sure you want to generate roll numbers for this exam? This action cannot be undone.`,
      title: 'Confirm Generate Roll No',
      icon: 'fa fa-question'
    };
    
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, confirmData);
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.performGenerateRollNo();
      }
    });
  }

  performGenerateRollNo() {
    this.isGeneratingRollNo = true;
    this.spinner.show();

    const payload = {
      ShId: this.selectedExamId
    };

    this.umsService.generateRollNo(payload).subscribe({
      next: (res) => {
        this.isGeneratingRollNo = false;
        this.spinner.hide();
        
        if (res.status) {
          let data = {
            message: res.message || 'Roll numbers generated successfully!',
            title: 'Success',
            icon: 'fas fa-check'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          
          this.fetchCollegeCenters(this.selectedExamId);
        } else {
          let data = {
            message: res.message || 'Failed to generate roll numbers.',
            title: 'Error',
            icon: 'fas fa-close'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.isGeneratingRollNo = false;
        this.spinner.hide();
        
        let errorMessage = error.error?.message || 'Failed to generate roll numbers. Please try again.';
        let data = {
          message: errorMessage,
          title: 'Error',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  saveCenterChanges() {
    if (this.isAllFinalized()) {
      let data = {
        message: 'Cannot save changes. All records are already finalized.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    const selectedChanges = this.collegeList.filter(college => college.SelectedCenter !== null);
    
    if (selectedChanges.length === 0) {
      let data = {
        message: 'No changes to save. Please select new centers for the colleges.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    let confirmData = {
      message: `You are about to update centers for ${selectedChanges.length} college(s). Do you want to proceed?`,
      title: 'Confirm Update',
      icon: 'fa fa-question'
    };
    
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, confirmData);
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.performCenterUpdate();
      }
    });
  }

  performCenterUpdate() {
    this.spinner.show();

    const selectedChanges = this.collegeList
      .filter(college => college.SelectedCenter !== null)
      .map(college => ({
        CgCode: college.CgCode,
        Cent: college.SelectedCenter.CgCode
      }));

    const jsonPayload = JSON.stringify(selectedChanges);

    const payload = {
      ShId: this.selectedExamId,
      Json: jsonPayload
    };

    this.umsService.updateCollegeCenters(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          let successMessage = res.message || 'Center changes saved successfully!';
          
          let details = '';
          if (res.data) {
            details = ` (${res.data.updatedCount} centers updated)`;
          }
          
          let data = {
            message: successMessage + details,
            title: 'Success',
            icon: 'fas fa-check'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          
          this.fetchCollegeCenters(this.selectedExamId);
        } else {
          let data = {
            message: res.message || 'Failed to save center changes.',
            title: 'Error',
            icon: 'fas fa-close'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        let errorMessage = error.error?.message || 'Failed to save center changes. Please try again.';
        
        if (error.error && typeof error.error === 'string') {
          errorMessage = error.error;
        }
        
        let data = {
          message: errorMessage,
          title: 'Error',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  getCenterDisplayName(center: any): string {
    if (!center) return '';
    return `${center.CgCode} - ${center.CgName}`;
  }

  getCurrentCenterDisplay(college: CollegeCenter): string {
    if (!college.Cent) return 'No Center Assigned';
    if (college.CentName && college.CentName.trim() !== '') {
      return `${college.Cent} - ${college.CentName.trim()}`;
    }
    return college.Cent;
  }

  hasCollegeChanged(college: CollegeCenter): boolean {
    if (!college.SelectedCenter) return false;
    return college.SelectedCenter.CgCode !== college.OriginalCent;
  }

  getPendingChangesCount(): number {
    return this.collegeList.filter(college => 
      college.SelectedCenter !== null && 
      college.SelectedCenter.CgCode !== college.OriginalCent
    ).length;
  }

  hasPendingChanges(): boolean {
    return this.getPendingChangesCount() > 0;
  }

  getChangeSummary(): string {
    const changed = this.collegeList.filter(college => 
      college.SelectedCenter !== null && 
      college.SelectedCenter.CgCode !== college.OriginalCent
    );
    
    if (changed.length === 0) return '';
    
    return changed.map(college => 
      `${college.CgName}: ${college.OriginalCent || 'None'} → ${college.SelectedCenter.CgCode}`
    ).join('; ');
  }

  getTotalStudents(): number {
    const total = this.collegeList.reduce((total, college) => total + (college.StudentCount || 0), 0);
    console.log('Total Students:', total);
    return total;
  }

  getCollegesWithChanges(): number {
    return this.collegeList.filter(college => college.SelectedCenter !== null).length;
  }

  revertToOriginal(college: CollegeCenter) {
    if (college.OriginalCent) {
      const originalCenter = this.allCentersList.find(c => c.CgCode === college.OriginalCent);
      if (originalCenter) {
        college.SelectedCenter = originalCenter;
      } else {
        college.SelectedCenter = { 
          CgCode: college.OriginalCent, 
          CgName: college.OriginalCentName || '' 
        };
      }
    }
  }

  clearSelectedCenter(college: CollegeCenter) {
    college.SelectedCenter = null;
  }

  resetForm() {
    this.collegeList = [];
    this.istableShow = false;
    this.CenterAllocationForm.patchValue({
      SessionId: this.SessionNo || null,
      CoFcCode: null,
      CoCode: null,
      Exam: null
    });
    this.CourseList = [];
    this.filteredListCourse = [];
    this.ExamFilterList = [];
    this.selectedShift = null;
    this.searchTerm = '';
    this.filteredCenterList = [...this.allCentersList];
    this.tempFilteredCenterList = [...this.allCentersList];
    this.isGeneratingRollNo = false;
    this.isSubmittingFinal = false;
    this.canUpdate = true;
  }

  get canUpdateCenters(): boolean {
    return this.canUpdate && !this.isAllFinalized();
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }
  generateReport() {
    if (!this.selectedExamId) {
      let data = {
        message: 'Please select an exam first.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }
    if (!this.isExamFinalized()) {
      let data = {
        message: 'Report can only be generated after the exam is fully finalized.',
        title: 'Information',
        icon: 'fas fa-info-circle'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    this.isGeneratingReport = true;
    this.spinner.show();

    this.umsService.getExcelReport({ ShId: this.selectedExamId }).subscribe({
      next: (res: any) => {
        this.isGeneratingReport = false;
        this.spinner.hide();

        if (!res.status || !res.data || res.data.length === 0) {
          let data = {
            message: res.message || 'No data available for the report.',
            title: 'Information',
            icon: 'fas fa-info-circle'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          return;
        }

        const columnMap = [
          { header: 'Seat No', field: 'RollNo' },
          { header: 'PRN No', field: 'RgNo' },
          { header: 'College Code', field: 'CgCode' },
          { header: 'College Name', field: 'College' },
          { header: 'Center Code', field: 'Cent' },
          { header: 'Center Name', field: 'Center' }
        ];
        const rows = res.data.map((item: any) => {
          return columnMap.map(col => item[col.field] ?? '');
        });

        const headers = columnMap.map(col => col.header);
        const worksheetData = [headers, ...rows];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        worksheet['!cols'] = headers.map(() => ({ wch: 20 }));

        const workbook: XLSX.WorkBook = {
          Sheets: { 'Center Roll Report': worksheet },
          SheetNames: ['Center Roll Report']
        };

        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });

        saveAs(
          new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }),
          `CenterAllocation_Exam_${this.selectedExamId}.xlsx`
        );

        let successData = {
          message: 'Report downloaded successfully!',
          title: 'Success',
          icon: 'fas fa-check'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, successData);
      },
      error: (error: HttpErrorResponse) => {
        this.isGeneratingReport = false;
        this.spinner.hide();
        let errorMessage = error.error?.message || 'Failed to generate report. Please try again.';
        let data = {
          message: errorMessage,
          title: 'Error',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }
}